import React, { useEffect, useRef, useState } from 'react';
import { saveAs } from 'file-saver';
import { ReactComponent as PlusIcon } from '../../../assets/images/svg/plus-icon-blue.svg';
import { ReactComponent as FileIcon } from '../../../assets/images/svg/Googledocs.svg';
import { ReactComponent as DownloadIcon } from '../../../assets/images/svg/Download-icon.svg';
import { ReactComponent as DeleteIcon } from '../../../assets/images/svg/Dustbin-delete.svg';
import './ticker.less';
import { ALLOWED_FILE_TYPES_TICKER, CSV_XLSX_WARNING, GUTTOR_SPACE, INCORRECT_NAMING, INDIAN_DATE_FORMAT, specialCharPattern } from '../../../shared/constants/commonConstants';
import { useDispatch } from 'react-redux';
import {
  saveTickerData,
  uploadTickerFile,
} from '../../../store/actions/newAdmissionAction';

import moment from 'moment';
import { Button, Col, Form, Row } from 'antd';
import FormInputDate from '../../../shared/components/crmFormElement/FormInputDate/FormInputDate';
import { isEmpty } from 'lodash';

type FileTypes = 'csv' | 'xlsx';

const TickerConfiguration: React.FC = (): any => {
  const [fileupload, setfileupload] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [overrideTicker, setOverrideTicker] = useState<boolean>(false);
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [tickerResponse, setTickerResponse] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [overrideTickerMessages, setOverrideTickerMessages] = useState({});
  const dispatch = useDispatch();
  const [tickerForm] = Form.useForm();
  const messageContainerRef = useRef<HTMLDivElement>(null);

  useEffect((): any => {
    dispatch(uploadTickerFile(onSuccess, onError));
  }, []);

  const getFileType = (fileName: string): FileTypes | null => {
    const extension = fileName?.split('.')?.pop()?.toLowerCase();
    if (extension && ALLOWED_FILE_TYPES_TICKER.includes(extension)) {
      return extension as FileTypes;
    }
    return null;
  };

  const getFile = (): any => {
    pushMessage('');
    document?.getElementById('file-upload')?.click();
  };

  const validateInput = (filename: any): boolean => {
    return specialCharPattern.test(filename);
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>): any => {
    const file = event?.target?.files && event?.target?.files[0];
    if (file) {
      if (overrideTicker) {
        if (startDate && endDate) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      } else {
        setDisabled(false);
      }
      const fileType = getFileType(file?.name);
      if (validateInput(file?.name)) {
        pushMessage(INCORRECT_NAMING, 'error');
      } else if (fileType && ALLOWED_FILE_TYPES_TICKER.includes(fileType)) {
        setUploadedFile(file);
        setfileupload(true);
      } else {
        pushMessage(CSV_XLSX_WARNING, 'error');
      }
    }
  };
  const onSuccess = (base64String: any, lastModifiedDate: any, overRideFrom: any, overRideTo: any, defaultConfiguration: any): any => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters?.length);
    for (let i = 0; i < byteCharacters?.length; i++) {
      byteNumbers[i] = byteCharacters?.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'text/csv' });

    const preFile = new File([blob], 'Provider list.csv', { type: 'text/csv' });
    setTickerResponse(lastModifiedDate);
    setUploadedFile(preFile);
    setfileupload(true);
    setOverrideTicker(!isEmpty(defaultConfiguration));
    setOverrideTickerMessages(defaultConfiguration);
    if (overRideFrom && overRideTo) {
      setDisabled(true);
      setStartDate(overRideFrom);
      setEndDate(overRideTo);
      tickerForm.setFieldsValue({startDate: moment(overRideFrom), endDate: moment(overRideTo)});
    } else {
      if (uploadedFile !== null) {
        setDisabled(false);
      }
    }
  };
  const onError = (error: string): any => {
    setTickerResponse('');
    pushMessage(error, 'error');
  };

  const deleteUploadedFile = (): any => {
    pushMessage('');
    setTickerResponse('');
    setDisabled(true);
    setUploadedFile(null);
    setfileupload(false);
  };

  const handleFileDownload = (): any => {
    if (uploadedFile) {
      saveAs(uploadedFile, uploadedFile.name);
    }
  };

  const pushMessage = (successMessages: any, type?: any): any => {
    if (messageContainerRef.current) {
      messageContainerRef.current.innerHTML = '';
      const messageElement = document.createElement('div');
      messageElement.className = 'banner-notification';
      // Apply different styles based on the type
      if (type === 'error') {
        messageElement.style.color = '#FF6264';
      } else if (type === 'success') {
        messageElement.style.color = '#16B484'; // Default color or other color
      }

      messageElement.textContent = successMessages;
      messageContainerRef.current?.appendChild(messageElement);
    }
  };

  const Publish = (): any => {
    const payload: any = {
      file: uploadedFile,
      IsOverRideTicker: overrideTicker,
    };
    if (overrideTicker && startDate && endDate) {

      const formattedStartDate = moment(startDate)?.format('YYYY-MM-DDTHH:mm:ss');
      const formattedEndDate = moment(endDate)?.format('YYYY-MM-DDTHH:mm:ss');
      payload.OverRideFrom = formattedStartDate;
      payload.OverRideTo = formattedEndDate;
    }
    setLoading(true);
    dispatch(saveTickerData(payload, onPublishSuccess, onPublishError));
  };

  const onPublishSuccess = (message: any): any => {
    setLoading(false);
    setDisabled(true);
    pushMessage(message, 'success');
    dispatch(uploadTickerFile(onSuccess, onError));
  };

  const onPublishError = (error: any): any => {
    setLoading(false);
    pushMessage(error, 'error');
  };

  const formatDate = (date: any): string => {
    if (moment?.isMoment(date)) {
      return date?.format('YYYY-MM-DDTHH:mm:ss');
    } else if (date instanceof Date) {
      return moment(date)?.format('YYYY-MM-DDTHH:mm:ss');
    } else {
      throw new Error('Invalid Date object');
    }
  };

  // showing override ticker messages
  const TickerMessages = (message: any): any => {
    const MAX_TICKERS = 3;
    const overrideText = message?.overrideTickerMessages;
    const tickerData = Array?.from({ length: MAX_TICKERS }, (_: any, index: any): any => {
      const tickerNumber = index + 1;
      return {
        message: overrideText[`ticker${tickerNumber}Message`] || '',
        ctaMessage: overrideText[`ticker${tickerNumber}CTA`] || '',
        ctaLink: overrideText[`ctA${tickerNumber}Link`] || '',
      };
    });

    return (
      <div>
        {tickerData?.map((ticker: any, index: any): any => (
          <div key={index}>
            <span><b>{`Ticker${index + 1} Message:`}</b> {`${ticker.message || '-'} `}</span> &nbsp;
            <span><b>{`CTA${index + 1} Message:`}</b> {`${ticker.ctaMessage || '-'} `}</span> &nbsp;
            <span><b>{`CTA${index + 1} Link:`}</b> {`${ticker.ctaLink || '-'}`}</span>
            <br />
          </div>
        ))}
      </div>
    );
  };

  const handleDateChange = (type: 'start' | 'end', date: any): void => {
    pushMessage('');
    try {
      const formattedDate = formatDate(date);
      if (type === 'start') {
        setStartDate(formattedDate);
      } else if (type === 'end') {
        setEndDate(formattedDate);
      }

      // Check if both start and end dates are set
      const formValues = tickerForm?.getFieldsValue() || {};
      const tickerStartDate = formValues?.startDate;
      const tickerEndDate = formValues?.endDate;
      if (uploadedFile !== null && tickerStartDate && tickerEndDate) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } catch (error) {
      console.error('Error handling date change:', error);
      setDisabled(true);
    }
  };

  const handleRadioChange = (value: boolean): any => {
    pushMessage('');
    tickerForm?.resetFields();
    setStartDate(null);
    setEndDate(null);
    setOverrideTicker(value);
    setDisabled(uploadedFile !== null ? value : true);
    setOverrideTickerMessages({});
  };
  const disableDatesBeforeStart = (current: any): any => {
    const currentDate = current ? new Date(current) : null;
    if (!startDate) {
      return false;
    }
    const start = new Date(startDate);
    return currentDate && start && currentDate < start;
  };

  return (
    <React.Fragment>
      <div className="claimListView ticker-font">

        <p className="ticket-header">Ticker Configuration</p>
        <hr className="line-break" />
        <div className="main-box">
          <div>
            <p className="upload-text">Upload Active File</p>
          </div>
          {!fileupload ? (
            <div>
              <input
                type="file"
                accept=".csv, .xlsx"
                style={{ display: 'none' }}
                id="file-upload"
                onChange={handleFileUpload}
              />
              <button className="upload-button" onClick={(): any => getFile()}>
                <PlusIcon className="upload-icon" />
                Upload File
              </button>
              <p className="warning">
                File format needs to be<span className="files">.csv,.xlsx</span>
              </p>
            </div>
          ) : (
            <div className="upload-display">
              <FileIcon />

              <span className="uploaded-file-text">{uploadedFile?.name}</span>
              {tickerResponse && <span className="file-modified-text">
                Uploaded on {moment(tickerResponse)?.format(INDIAN_DATE_FORMAT)}</span>}
              <div className="upload-icon">
                <DownloadIcon className="download-icon" onClick={handleFileDownload} />
                <DeleteIcon className="delete-icon" onClick={deleteUploadedFile} />
              </div>
            </div>
          )}
          <div className="radio">
            <p className="font-14 override-ticker">Override Ticker ?</p>
            <div className="input-holder font-14 m-top-5">
              <label>
                <input
                  type="radio"
                  name="overrideTicker"
                  value="yes"
                  checked={overrideTicker === true}
                  onChange={(): any => handleRadioChange(true)}
                />
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="overrideTicker"
                  value="no"
                  checked={overrideTicker === false}
                  onChange={(): any => handleRadioChange(false)}
                />
                No
              </label>
            </div>
          </div>
          {overrideTicker ? <div className="ticker-calendar">
            <Form form={tickerForm}>
              <Row gutter={GUTTOR_SPACE}>
                <Col md={12} className="ticker-pl-0">
                  <FormInputDate
                    detail={{
                      key: 'startDate',
                      label: 'Start Date',
                      size: 24,
                      showTime: true,
                      allowClear: false,
                      onChange: (date: any, dateString: string): void => handleDateChange('start', date),
                    }}
                  />
                </Col>
                <Col md={12} className="ticker-pl-0">
                  <FormInputDate
                    detail={{
                      key: 'endDate',
                      label: 'End Date',
                      size: 24,
                      showTime: true,
                      allowClear: false,
                      onChange: (date: any, dateString: string): void => handleDateChange('end', date),
                      disabledDate: disableDatesBeforeStart,
                    }}
                  />
                </Col>
              </Row>
            </Form>
          </div> : null}
          {(overrideTicker && !isEmpty(overrideTickerMessages)) ? <Row>
            <div className="override-text">
              <p>
                <span><b>Override Ticker Message:</b></span>
                <TickerMessages overrideTickerMessages={overrideTickerMessages} />
              </p>
            </div>
          </Row> : <></> }
          <Button className="publish-button" type="primary" onClick={(): any => Publish()} loading={loading} disabled={disabled}>
            Publish
          </Button>
          <div className="Message-content" ref={messageContainerRef} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default TickerConfiguration;
